jQuery( document ).ready( function ( $ ) {
	const options = {
		root: null,
		rootMargin: '-45% 0px -45% 0px',
		threshold: 0,
	}

	const sections = document.querySelectorAll( 'section:not(.footer-section), footer' );
	const callback = function ( entries, observer ) {
		entries.forEach( entry => {
			if ( entry.isIntersecting ) {
				var eventCategory = $( entry.target ).data( 'event-category' );
				if ( eventCategory !== undefined && eventCategory != "" ) {
					dataLayer.push( {'event': 'scrolled', 'eventCategory': eventCategory} );
				}
				observer.unobserve( entry.target );
			}
		} );
	};

	const observer = new IntersectionObserver( callback, options );

	sections.forEach( section => {
		observer.observe( section );
	} )
} )
